
/**
 * 全局扩展字段
 */
const mtaGlobalConfig = {
  // --------sdk事件上报用到的参数----------
  // MTA 香港钱包 cid/sid
  sid: '500008935',
  cid: '500009774',

  // --------cli录入A/BC所用到的参数-----------------
  auth: {
    // 鉴权信息
    groupId: 10078, // 香港钱包在海雀的Id
    appKey: 'rta_access', // 数据源
  },
  scanInfo: {
    // 扫埋点信息所需要的信息
    route: './router.ts', // 路由文件路径，相对于当前目录或 -p指定的目录
    tempIdForA: 109, // 录入A时携带的模板Id（注：由于海雀真正生成事件A.B.C时，用的是B.C携带的扩展字段，所以这里实际没有用。推动海雀支持中）

    tempIdForBC: 230, // 录入BC时携带的模板Id

    subgroupRuleId: 64, // 扩展字段必须符合的约束规则（提前在海雀中定义，海雀平台查询ID http://fit.oa.com/hq/manage/rule）
    
    fieldTypeForBC: 1,  // 事件扩展字段来源，1: 表示取组件参数(默认)，2: 表示取页面参数，3: 表示取组件+页面拼接的参数

    productor: 'tonyxue', // 产品负责人
  },

  // sdk上报和cli录入A(只录BC的话，用不上)都要用到的参数
  group: 'wallet', // 业务，也是录入A的一级分类，如：香港钱包可选值 wallet/prom
  groupDesc: '运营', // 业务描述
  project: 'charity', // 项目名，也是录入A的二级分类名
  projectDesc: '慈善项目', // 项目描述，也是录入A的二级分类描述
};

export default mtaGlobalConfig;
